// extracted by mini-css-extract-plugin
export default {"container":"HtmlContentBadge-module_container__epBuA"};